import { combineReducers } from "redux";
import dcmReducer from "./dicomReducer";
const rootReducer = combineReducers({
    dcm: dcmReducer
})
export default rootReducer